import { Type } from "class-transformer";

export class OrderItemMiscStateV2 {
    public Id: number;
    public Uuid: string;
    public OrderId: number;
    @Type(() => Date)
    public CreatedAt: Date;
    public CustomerNo: string;
    
    public Reference: string;
    public Ecommerce: string;
    public EcommerceNoUnique: string;
    public EcommerceVariantCode: string;
    public Amount: number;
    
    public Description: string;
    public ProductLineCode: string;
    
    public KidTeen: boolean;
    public ToolsIncluded: boolean;
    public Type: number;
    
    public DiscountCode: string;
    public DiscountPercentage: number;
    
    public PriceJson: string;
    
    public GrantProductLineStatus: boolean;
} 